import { Icon } from "@/components/Icon";

export const Loading = ({ text }: { text?: string }) => {
    return (
        <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/50 dark:bg-slate-900/50 backdrop-blur-sm">
            <Icon
                value="loader"
                className="animate-spin text-primary mb-4"
                size={40}
            />
            {text && (
                <span className="text-slate-600 dark:text-slate-300 font-medium">
                    {text}
                </span>
            )}
        </div>
    );
};
